'use strict';

import { Entity } from '../Entity';

export class IndProvider extends Entity {
  protected indProviderId;
  protected indProviderStatus;
  protected indProviderImportance;
  protected indProviderFirstname;
  protected indProviderLastname;
  protected indProviderSpecialty;
  protected indProviderFacility;
  protected indProviderNote;
  protected indProviderNetworks;
  protected indProviderInclude;
  protected indProviderPhone;
  protected indProviderNum;
  protected indProviderAddress;
  protected archived;
  protected dateTimeArchived;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indProviderId = data.indProviderId;
    this.indProviderStatus = data.indProviderStatus;
    this.indProviderImportance = data.indProviderImportance;
    this.indProviderFirstname = data.indProviderFirstname;
    this.indProviderLastname = data.indProviderLastname;
    this.indProviderSpecialty = data.indProviderSpecialty;
    this.indProviderFacility = data.indProviderFacility;
    this.indProviderNote = data.indProviderNote;
    this.indProviderNetworks = data.indProviderNetworks;
    this.indProviderInclude = data.indProviderInclude;
    this.indProviderPhone = data.indProviderPhone;
    this.indProviderNum = data.indProviderNum;
    this.indProviderAddress = data.indProviderAddress;
    this.archived = data.archived;

    if (data.dateTimeArchived) {
      const dateTimeArchived = data.dateTimeArchived.date.split(' ')[0].split('-');
      this.dateTimeArchived =
        dateTimeArchived[1] + '/' + dateTimeArchived[2] + '/' + dateTimeArchived[0];
    }
  }

  public getIndProviderId() {
    return this.indProviderId;
  }

  public getIndProviderStatus() {
    return this.indProviderStatus;
  }

  public setIndProviderStatus(indProviderStatus) {
    this.indProviderStatus = indProviderStatus;

    return this;
  }

  public getIndProviderImportance() {
    return this.indProviderImportance;
  }

  public setIndProviderImportance(indProviderImportance) {
    this.indProviderImportance = indProviderImportance;

    return this;
  }

  public getIndProviderFirstname() {
    return this.indProviderFirstname;
  }

  public setIndProviderFirstname(indProviderFirstname) {
    this.indProviderFirstname = indProviderFirstname;

    return this;
  }

  public getIndProviderLastname() {
    return this.indProviderLastname;
  }

  public setIndProviderLastname(indProviderLastname) {
    this.indProviderLastname = indProviderLastname;

    return this;
  }

  public getIndProviderSpecialty() {
    return this.indProviderSpecialty;
  }

  public setIndProviderSpecialty(indProviderSpecialty) {
    this.indProviderSpecialty = indProviderSpecialty;

    return this;
  }

  public getIndProviderFacility() {
    return this.indProviderFacility;
  }

  public setIndProviderFacility(indProviderFacility) {
    this.indProviderFacility = indProviderFacility;

    return this;
  }

  public getIndProviderNote() {
    return this.indProviderNote;
  }

  public setIndProviderNote(indProviderNote) {
    this.indProviderNote = indProviderNote;

    return this;
  }

  public getIndProviderNetworks() {
    return this.indProviderNetworks;
  }

  public setIndProviderNetworks(indProviderNetworks) {
    this.indProviderNetworks = indProviderNetworks;

    return this;
  }

  public getIndProviderInclude() {
    return this.indProviderInclude;
  }

  public setIndProviderInclude(indProviderInclude) {
    this.indProviderInclude = indProviderInclude;

    return this;
  }

  public getIndProviderPhone() {
    return this.indProviderPhone;
  }

  public setIndProviderPhone(indProviderPhone) {
    this.indProviderPhone = indProviderPhone;

    return this;
  }

  public getIndProviderNum() {
    return this.indProviderNum;
  }

  public setIndProviderNum(indProviderNum) {
    this.indProviderNum = indProviderNum;

    return this;
  }

  public getIndProviderAddress() {
    return this.indProviderAddress;
  }

  public setIndProviderAddress(indProviderAddress) {
    this.indProviderAddress = indProviderAddress;

    return this;
  }

  public isArchived() {
    return this.archived;
  }

  public getDateTimeArchived() {
    return this.dateTimeArchived;
  }
}
